import BaseAPI from './base'

const auth = {
  login(params) { return BaseAPI('post', '/Auth/Login', params) },
  // logout() { return BaseAPI('get', 'Auth/logout' ) }
}

export default auth
